var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMolecly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512.8500000000001,
    height: 80.60815521927171,
    viewBox: "0 0 350 55.01190275274465",
    className: "looka-1j8o68f",
    id: "svg1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1015"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1016",
    featurekey: "ewgXDI-0",
    transform: "matrix(3.7934013874155212,0,0,3.7934013874155212,-4.704844270285472,-21.59701465987168)",
    fill: "#1d348a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.998 20 l-2.9199 0 l-0.92773 -10.635 l-3.5742 10.635 l-1.8945 0 l-3.5742 -10.635 l-0.9375 10.635 l-2.9297 0 l1.1816 -14.111 l4.1797 0 l3.0078 8.8574 l3.0469 -8.8574 l4.1797 0 z M27.31448125 20.19531 c-4.1504 0 -7.2168 -2.832 -7.2168 -7.2559 c0 -4.4336 3.0664 -7.2461 7.2168 -7.2461 c4.1406 0 7.207 2.8125 7.207 7.2461 c0 4.4238 -3.0664 7.2559 -7.207 7.2559 z M27.31448125 17.5098 c2.4316 0 4.2969 -1.709 4.2969 -4.5703 c0 -2.8516 -1.8652 -4.5508 -4.2969 -4.5508 s-4.2969 1.6992 -4.2969 4.5508 c0 2.8613 1.8652 4.5703 4.2969 4.5703 z M40.146525 17.4121 l4.4238 0 l0 2.5879 l-7.3535 0 l0 -14.111 l2.9297 0 l0 11.523 z M54.99046875 8.467 l-5.2344 0 l0 3.2031 l4.6387 0 l0 2.5488 l-4.6387 0 l0 3.1934 l5.2344 0 l0 2.5879 l-8.1836 0 l0 -14.111 l8.1836 0 l0 2.5781 z M64.257840625 20.19531 c-4.1504 0 -7.2168 -2.8223 -7.2168 -7.2559 s3.0664 -7.2461 7.2168 -7.2461 c3.1445 0 5.6641 1.6113 6.6699 4.2871 l-2.7344 0.99609 c-0.625 -1.6406 -2.1191 -2.5879 -3.9355 -2.5879 c-2.4316 0 -4.2969 1.6992 -4.2969 4.5508 s1.8652 4.5605 4.2969 4.5605 c1.8164 0 3.3105 -0.95703 3.9355 -2.5977 l2.7344 0.99609 c-1.0059 2.6758 -3.5254 4.2969 -6.6699 4.2969 z M76.25980625 17.4121 l4.4238 0 l0 2.5879 l-7.3535 0 l0 -14.111 l2.9297 0 l0 11.523 z M93.50575 5.888999999999999 l-4.6387 7.3535 l0 6.7578 l-2.9395 0 l0 -6.6895 l-4.668 -7.4219 l3.2422 0 l2.8809 4.8047 l2.8906 -4.8047 l3.2324 0 z",
    id: "path1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMolecly);
export default __webpack_public_path__ + "static/media/molecly.a4d7336279af14542313bc0594955fc6.svg";
export { ForwardRef as ReactComponent };